<div class="page-content ">
  <div class="no-scroll">
    <div class="row">
      <div class="col-8" class="congratulations-text">
        <p>Congratulations, you have sold your vehicle.</p>
        <p>If you would like to leave us a review on <br/> Trustpilot, please scan the QR below. </p>
      </div>
    </div>
    <div class="row">
     <div class="col-4 qr-image-container">
        <app-qr [qrData]="qrData()" [isModal]="false"></app-qr>
        <img class="qr-image" src="../../assets/images/scan_me.svg" alt="">
      </div>
      <div class="col-1"></div>
      <div class="col-7 sold-image-container">
        <img class="sold-image" src="../../assets/images/sold.png" alt="">
      </div>
    </div>
    <div class="purchase-time row">
      <div *ngIf="purchaseTime" class="col-4 offset-8">
        Purchase Time: <span *ngIf="purchaseTime.hours > 0">{{purchaseTime.hours}}:</span><span
          *ngIf="purchaseTime.minutes < 10">0</span>{{purchaseTime.minutes}}:<span
          *ngIf="purchaseTime.seconds < 10">0</span>{{purchaseTime.seconds}}
      </div>
    </div>
  </div>
</div>